import React from 'react';
import SectionLayout from '../layouts/section-layout';
import BasicCard from './ui-components/basic-card';
import { motion } from 'framer-motion';

import { sectionLayoutChildAnimation } from '../utils/animations';

export default function Section4() {
  const cards = [
    {
      title: 'Transform Trails with Your Phone: AR Accessibility Mapping',
      body: 'Turn your iPhone into a powerful trail accessibility tool. Adapt’s augmented reality feature allows you to effortlessly capture precise measurements of cross-slope, trail width, and grade, point-by-point. Instantly integrate this data into digital trail maps, empowering all users with comprehensive accessibility information',
    },
    {
      title: 'Your Shared Trail Network',
      body: 'Experience a growing network of accessible trails. Every trail mapped by our partners, once reviewed by NeoTreks, is added to the app, ensuring you have access to the best accessible trails, anytime, anywhere.',
    },
    {
      title: 'Data for Good: Streamlining Nonprofit Reporting with Adapt',
      body: 'Adapt provides nonprofits with powerful tools to map trails and generate impactful data for funding and reporting. Easily export post-hike data, including mileage, elevation, and photo points, to strengthen your grant applications and external communications.',
    },
  ];

  return (
    <SectionLayout>
      <div className="pb-8 mb-8 border-b-2 border-gray-300">
        <motion.div
          variants={sectionLayoutChildAnimation}
          className="max-w-2xl mx-auto text-center"
        >
          {/*<p className="my-1 text-3xl  text-gray-600 font-bold">
            Set your applications apart from the competition
          </p>
          <p className="my-1  text-lg  font-normal text-gray-700 ">
            Create a free developer account to add AccuTerra Maps to your
            applications today
          </p>*/}
        </motion.div>

        <motion.div
          variants={sectionLayoutChildAnimation}
          className="grid grid-cols-1 md:grid-cols-3 gap-4 text-left  my-10"
        >
          {cards.map((card) => (
            <BasicCard
              title={card.title}
              body={card.body}
              cta={card.cta}
              link={card.link}
              key={card.title}
            />
          ))}
        </motion.div>
      </div>
    </SectionLayout>
  );
}
